<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <h5 class="info-text">Ahora veamos a qué te dedicas</h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_STUDY_LEVEL }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainStudyLevel"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Nivel de estudio</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainStudyLevel"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_EMPLOYMENT }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainEmployment"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Ocupación Actual</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainEmployment"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_INCOME_SALARY }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainIncomeSalary"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Ingresos Mensuales</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainIncomeSalary"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_EXPENSES }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainMonthlyExpenses"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Gastos Mensuales</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainMonthlyExpenses"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <label class="md-layout-item md-size-15 md-form-label">
              Días de pago
            </label>
            <div class="md-layout-item">
              <md-checkbox
                v-for="(day, i) in 31"
                :key="day"
                v-model="paymentDaysAsArray[i]"
                :value="day"
                >{{ day }}</md-checkbox
              >
            </div>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="numberPeopleInCharge"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
              >
                <md-icon>room</md-icon>
                <label>Años de experiencia</label>
                <md-select v-model="clientJob.yearsExperience" name="select">
                  <md-option :value="null" disabled>Seleccionar años</md-option>
                  <md-option :value="0">Menos de 1 año</md-option>
                  <md-option v-for="people in 4" :key="people" :value="people"
                    >{{ people }} años</md-option
                  >
                  <md-option :value="5">Más de 4 años</md-option>
                </md-select>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refFamiliarName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Nombre de la empresa</label>
                <md-input v-model="clientJob.enterpriseName" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refFamiliarName"
              rules="required|max_value:9999999999|min_value:100000000"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Nit de la empresa</label>
                <md-input v-model="clientJob.enterpriseNit" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="refFamiliarName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Cargo en la empresa</label>
                <md-input v-model="clientJob.jobRole" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_ENTERPRISE_SECTOR }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainEnterpriseSectorId"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Sector de la empresa</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainEnterpriseSectorId"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>email</md-icon>
                <label>Correo de la empresa</label>
                <md-input v-model="clientJob.enterpriseEmail" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="phoneNumber"
              rules="required|max_value:9999999|min_value:1000000"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>phone</md-icon>
                <label>Teléfono de la empresa</label>
                <md-input v-model="clientJob.enterprisePhone" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="phoneNumber"
              rules="max_value:99999|min_value:10"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>phone</md-icon>
                <label>Extensión de la oficina</label>
                <md-input v-model="clientJob.enterprisePhoneExt" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ApolloQuery
              :query="require('../../../graphql/query/DomainGroup.gql')"
              :variables="{ fieldName: Constants.DOMAIN_CONTRACT_TYPE }"
              ><template v-slot="{ result: { data } }">
                <ValidationProvider
                  name="capDomainContractTypeId"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                  <md-field
                    :class="[
                      { 'md-error': failed },
                      { 'md-valid': passed },
                      { 'md-form-group': true }
                    ]"
                  >
                    <md-icon>picture_in_picture</md-icon>
                    <label for="select">Tipo de contrato</label>
                    <md-select
                      v-if="data"
                      v-model="capDomainContractTypeId"
                      name="select"
                    >
                      <md-option
                        v-for="docType in data.getDomain"
                        :key="docType.id"
                        :value="docType.id"
                        >{{ docType.value }}</md-option
                      >
                    </md-select>
                  </md-field>
                </ValidationProvider>
              </template>
            </ApolloQuery>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, max_value } from "vee-validate/dist/rules";
import Swal from "sweetalert2";
import Constants from "../../../constants";
import gql from "graphql-tag";

extend("required", required);
extend("max_value", max_value);
export default {
  components: {},
  props: {
    frontDefault: {
      type: String,
      default: "./img/capital77/cedula-frontal.webp"
    },
    backDefault: {
      type: String,
      default: "./img/capital77/cedula-trasera.webp"
    }
  },
  created() {
    this.$apollo
      .query({
        query: gql`
          query departments {
            departments {
              id: depId
              name: depName
              cities: capCities {
                id: cityId
                name: cityName
              }
            }
          }
        `
      })
      .then(data => {
        this.departments = data.data.departments;
      });
  },
  data() {
    return {
      clientJob: {
        enterpriseEmail: null,
        enterpriseName: null,
        enterpriseNit: null,
        enterprisePhone: null,
        enterprisePhoneExt: null,
        jobRole: null,
        yearsExperience: null
      },
      capDomainEnterpriseSectorId: null,
      capDomainContractTypeId: null,

      capDomainIncomeSalary: null,
      capDomainMonthlyExpenses: null,
      capDomainStudyLevel: null,
      capDomainEmployment: null,
      paymentDaysAsArray: [],
      model: {
        paymentDays: null
      },
      Constants: Constants
    };
  },
  methods: {
    validateAlmost1PD() {
      var hasDays = false;
      for (let index = 0; index < this.paymentDaysAsArray.length; index++) {
        const element = this.paymentDaysAsArray[index];
        if (element) hasDays = true;
      }
      this.model.paymentDays = this.paymentDaysAsArray.filter(Boolean).join();
      return hasDays;
    },
    validate() {
      if (this.clientJob.enterprisePhoneExt == "")
        this.clientJob.enterprisePhoneExt = null;
      if (!this.paymentDaysAsArray.length || !this.validateAlmost1PD()) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides los días de pago",
          timer: 2000,
          showConfirmButton: false
        });
      } else
        return this.$refs.form.validate().then(res => {
          this.$emit(
            "on-validated",
            res,
            this.model,
            this.capDomainIncomeSalary,
            this.capDomainMonthlyExpenses,
            this.capDomainStudyLevel,
            this.capDomainEmployment,
            this.clientJob,
            this.capDomainEnterpriseSectorId,
            this.capDomainContractTypeId
          );
          return res;
        });
    }
  }
};
</script>
<style></style>
